import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

export interface IDecisionDialogData {
    heading: string;
    descriptionHtml: string;
    buttons: IDecisionDialogButton[];
}

export interface IDecisionDialogButton {
    label: string;
    /** @see ViegaButtonComponent.type */
    style: string;
    dialogResult: any;
}

/**
 * A simple dialog with a title, description text and a collection of buttons.
 * The close button will always produce a dialogResult of false.
 */
@Component({
    selector: 'generic-decision-dialog',
    templateUrl: './generic-decision-dialog.component.html',
    styleUrls: ['./generic-decision-dialog.component.scss']
})
export class GenericDecisionDialogComponent implements OnInit {
    constructor(public dialogRef: MatDialogRef<GenericDecisionDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public dialogData: IDecisionDialogData) {}

    public ngOnInit(): void {}

    public buttonClick(dialogResult: any) {
        this.dialogRef.close(dialogResult);
    }
}



// WEBPACK FOOTER //
// ./src/viega-common/components/generic-decision-dialog/generic-decision-dialog.component.ts